import React from "react";

const Boat = ({
  size = 20,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2703 8.63984L16.25 8.29922V4.375C16.25 4.04348 16.1183 3.72554 15.8839 3.49112C15.6495 3.2567 15.3315 3.125 15 3.125H10.625V1.875C10.625 1.70924 10.5592 1.55027 10.4419 1.43306C10.3247 1.31585 10.1658 1.25 10 1.25C9.83424 1.25 9.67527 1.31585 9.55806 1.43306C9.44085 1.55027 9.375 1.70924 9.375 1.875V3.125H5C4.66848 3.125 4.35054 3.2567 4.11612 3.49112C3.8817 3.72554 3.75 4.04348 3.75 4.375V8.29922L2.72969 8.63984C2.48079 8.72282 2.26431 8.882 2.11091 9.09485C1.95752 9.3077 1.87498 9.56342 1.875 9.82578V11.875C1.875 16.6828 9.52266 18.65 9.84844 18.7312C9.94795 18.7561 10.0521 18.7561 10.1516 18.7312C10.4773 18.65 18.125 16.6828 18.125 11.875V9.82578C18.125 9.56342 18.0425 9.3077 17.8891 9.09485C17.7357 8.882 17.5192 8.72282 17.2703 8.63984ZM5 4.375H15V7.88281L10.1977 6.28203C10.0694 6.23926 9.93064 6.23926 9.80234 6.28203L5 7.88281V4.375ZM16.875 11.875C16.875 13.8211 15.025 15.2344 13.4727 16.0805C12.3674 16.667 11.2034 17.1354 10 17.4781C8.80385 17.139 7.64669 16.675 6.54766 16.0938C3.71875 14.5586 3.125 12.9523 3.125 11.875V9.82578L9.375 7.74219V13.125C9.375 13.2908 9.44085 13.4497 9.55806 13.5669C9.67527 13.6842 9.83424 13.75 10 13.75C10.1658 13.75 10.3247 13.6842 10.4419 13.5669C10.5592 13.4497 10.625 13.2908 10.625 13.125V7.74219L16.875 9.82578V11.875Z"
        fill={color}
      />
    </svg>
  );
};

export default Boat;
